import { render } from "./FooterCom.vue?vue&type=template&id=bce17130"
import script from "./FooterCom.vue?vue&type=script&lang=js"
export * from "./FooterCom.vue?vue&type=script&lang=js"

import "./FooterCom.vue?vue&type=style&index=0&id=bce17130&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__